import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "audioInput"
const AudioInputIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 13a2 2 0 0 0 2-2V6h3V4h-4v5.27A2 2 0 1 0 16 13m-.75 4H14v-2h-1.004a.997.997 0 0 1-.996-.999V2.999c0-.552.456-.999.996-.999h9.008c.55 0 .996.447.996.999v11.002c0 .552-.456.999-.996.999H18v2h-1.25A4.75 4.75 0 0 1 12 21.75 4.75 4.75 0 0 1 7.25 17v-4A3.25 3.25 0 0 0 4 9.75H2v-1.5h2A4.75 4.75 0 0 1 8.75 13v4a3.25 3.25 0 1 0 6.5 0"
      />
    </svg>
  )
}
export default AudioInputIcon
